import { render, staticRenderFns } from "./MdtDiseaseForm.vue?vue&type=template&id=7a1ee1f5&scoped=true"
import script from "./MdtDiseaseForm.vue?vue&type=script&lang=js"
export * from "./MdtDiseaseForm.vue?vue&type=script&lang=js"
import style0 from "./MdtDiseaseForm.vue?vue&type=style&index=0&id=7a1ee1f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ee1f5",
  null
  
)

export default component.exports